import { gql, useQuery } from '@apollo/client';

export const PO_SALE_ORDER_QUERY = gql`
  query PoSaleOrder($cd: String!) {
    poSaleOrder {
      poSaleOrders(
        page: 1
        pageSize: 1
        poSaleOrderCd: $cd
      ) {
        data {
          id
          cd
          orderDate
          orderType
          orderStatus
          sellType
          description
          referencePo
          orderSource
          deliveryAddress
          receiver
          nguoiDatHang
          ngayYeuCauGiaoHang
          ngayDatHang
          distributor {
            id
            cd
            name
          }
          customer {
            id
            cd
            name
            customerPriceClassId
            address1
          }
          salesman {
            id
            cd
            name
          }
          orderItems {
            id
            sortOrder
            qty
            unitId
            unitPrice
            unitPriceAfterTax
            totalPriceAfterTax
            isFreeItem
            product {
              id
              cd
              name
              tax
              barcode
              otherReference
            }
            warehouse {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const usePoSaleOrderQuery = (options?: any) => {
  return useQuery(PO_SALE_ORDER_QUERY, options);
};
